import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Icon from 'components/Icon'
import Button from 'components/form/Button'
import { DashboardTypes } from 'features/Codes'
import api from 'api/axios/foka'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { hideBackDrop, showBackDrop } from 'features/dialog/backDropSlice'
import { fail } from 'features/toast/Toast'
import { downloadCsvFile } from 'utils'
import { useDashboardTypeName } from 'features/dashboard/utils/hooks/useDashboardTypeName'

const DownloadAPIs = {
  [DashboardTypes.CAMPAIGN]: api.dashboard.downloadCampaignTable,
  [DashboardTypes.AD_GROUP]: api.dashboard.downloadAdGroupTable,
  [DashboardTypes.CREATIVE]: api.dashboard.downloadCreativeTable,
}

const DownloadButton = () => {
  const dispatch = useDispatch()
  const { type, name } = useDashboardTypeName()
  const {
    common: { from, to },
    filter: { filters },
    table: {
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { selectedIds: adGroupIds },
      config: {
        columns: { [type]: columns },
      },
    },
  } = useSelector(state => state.dashboard, shallowEqual)
  const { name: adAccountName } = useSelector(state => state.account.current)
  const { totalElements, sort } = useDashboardTableSelector()
  const handleDownload = async () => {
    if (totalElements === 0) {
      fail('다운로드할 데이터가 없습니다.')
    } else {
      dispatch(showBackDrop())
      try {
        const response = await DownloadAPIs[type]({
          from,
          to,
          sort,
          filters,
          dashboardColumns: columns,
          ...([DashboardTypes.AD_GROUP, DashboardTypes.CREATIVE].includes(
            type
          ) && { campaignIds }),
          ...(type === DashboardTypes.CREATIVE && { adGroupIds }),
        })
        downloadCsvFile(
          response.data,
          `${adAccountName}_${name}_${from}_${to}.csv`
        )
      } catch (e) {
        fail('알 수 없는 에러가 발생했습니다.')
      }
      dispatch(hideBackDrop())
    }
  }
  return (
    <Button line icon onClick={handleDownload}>
      <Icon name="download">다운로드</Icon>
    </Button>
  )
}
export default DownloadButton
